module.exports = __webpack_public_path__ + "img/placeholder-speaker.630d1978.png";